var MpPageProceduresAndLinks;

(function() {
    if (!document.querySelector('#vue-info-procedures-and-links')) {
        return;
    }

    MpPageProceduresAndLinks = new Vue({
        el: '#vue-info-procedures-and-links',

        mixins: [],

        data: {

            sectionList: [],
            columns: [{
                id: 0,
                nLinks: 0,
                sections: []
            }, {
                id: 1,
                nLinks: 0,
                sections: []
            }, {
                id: 2,
                nLinks: 0,
                sections: []
            }],

            overlay: null,

            searchTerm: '',

            isInitialized: false,
        },

        computed: {

            filteredLinks: function() {

                if (!this.isInitialized) {
                    return;
                }

                if (!this.searchTerm) {
                    return this.columns;
                }

                var linksFound = [];

                this.sectionList.forEach(section => {
                    var searchTerms = this.searchTerm.split(' ');

                    searchTerms.forEach((term) => {
                        term = term.toUpperCase();

                        var matchingLinks = section.links.filter((link) => {
                            return link.label.toUpperCase().indexOf(term) >= 0;
                        });

                        linksFound = linksFound.concat(matchingLinks);
                    });
                });

                return [{
                    id: 0,
                    nLinks: linksFound.length,
                    sections: [{
                        id: -1,
                        title: '',
                        links: linksFound
                    }]
                }];
            }
        },

        methods: {

            getLinkTarget: function(link) {
                return (link.target === '1') ? '_blank' : '_self';
            },

            getBestColumnIndex: function() {
                var best = 0;

                for (var i=1; i<this.columns.length; i++) {
                    best = (this.columns[best].nLinks <= this.columns[i].nLinks) ? best : i;
                }

                return  best;
            },

            addDomSection: function(section) {
                var sectionTmp = {
                    id: this.sectionList.length,
                    title: section.getAttribute('data-title'),
                    links: []
                };

                section.querySelectorAll('.js-section-link a').forEach((link) => {
                    sectionTmp.links.push({
                        label: link.parentNode.dataset.label,
                        target: link.parentNode.dataset.target,
                        url: link.parentNode.dataset.url
                    });
                });

                this.sectionList.push(sectionTmp);
            },

            distributeSections: function() {
                for (var i=0; i<this.sectionList.length; i++) {
                    var col = this.columns[this.getBestColumnIndex()];
                    col.nLinks += this.sectionList[i].links.length;
                    col.sections.push(this.sectionList[i]);
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.distributeSections();
            },

            onWordUpdate: function() {
                this.searchTerm = this.$refs.word.value;
            },

            onSearchSubmit: function(ev) {
                this.doSearch();
            },

            doSearch: function() {
                this.searchTerm = this.$refs.word.value;
            },
        },
        filters: {},

        mounted: function() {
            this.searchTerm = this.$refs.word.value;
            this.$refs.ssrSectionLinks.querySelectorAll('.js-section-links').forEach(this.addDomSection);
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {

        }
    });

})();
